document.addEventListener("DOMContentLoaded", function(){

    const items =
        document.querySelectorAll(".custom-faq-item");

    items.forEach(function(item){

        const question =
            item.querySelector(".custom-faq-question");

        const icon =
            item.querySelector(".custom-faq-icon");

        const answer =
            item.querySelector(".custom-faq-answer");

        question.addEventListener("click", function(){

            item.classList.toggle("active");

            if(item.classList.contains("active")){

                answer.style.display = "block";
                icon.innerHTML = "−";

            } else {

                answer.style.display = "none";
                icon.innerHTML = "+";

            }

        });

    });

});